// extracted by mini-css-extract-plugin
var _1 = "RightPanel-module__animateUploadProgressBarWidth--UY_RC";
var _2 = "RightPanel-module__animatedBackground--lNnI1";
var _3 = "1px";
var _4 = "RightPanel-module__headerControls--_dRRD";
var _5 = "RightPanel-module__iconButton--DGYLS";
var _6 = "RightPanel-module__iconButtons--Lbwt5";
var _7 = "RightPanel-module__isEnabled--laaLw";
var _8 = "RightPanel-module__isOpen--LvmyA";
var _9 = "RightPanel-module__isPinned--xVi2x";
var _a = "RightPanel-module__isResizing--WsKtD";
var _b = "150";
var _c = "RightPanel-module__resizeHandle--zchA_";
var _d = "544px";
var _e = "RightPanel-module__rightPanelHeader--VgRjA";
var _f = "RightPanel-module__rightPanelInner--cIP0Y";
var _10 = "RightPanel-module__rightPanelInnerContainer--bzUH4";
var _11 = "RightPanel-module__rightPanelInnerContent--WifhE";
var _12 = "321px";
var _13 = "RightPanel-module__rightPanelNewHeader--ubwZe";
var _14 = "RightPanel-module__rightPanelRoot--J5FUx";
var _15 = "RightPanel-module__rightPanelRootContainer--CGj4q";
var _16 = "RightPanel-module__rightPanelRootContent--CbgsB";
var _17 = "337px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "borderWidth", _4 as "headerControls", _5 as "iconButton", _6 as "iconButtons", _7 as "isEnabled", _8 as "isOpen", _9 as "isPinned", _a as "isResizing", _b as "layoutAnimationDurationMs", _c as "resizeHandle", _d as "resizeMaxWidth", _e as "rightPanelHeader", _f as "rightPanelInner", _10 as "rightPanelInnerContainer", _11 as "rightPanelInnerContent", _12 as "rightPanelMobileWidth", _13 as "rightPanelNewHeader", _14 as "rightPanelRoot", _15 as "rightPanelRootContainer", _16 as "rightPanelRootContent", _17 as "rightPanelWidth" }
